<template>
  <div>
    <div>
      {{ label }}:
    </div>
    <div
      v-for="(card, key) in storedCards"
      :key="'myCards' + key"
    >
      <span
        class="cc-details stored-cc"
      >
        <b-form-radio
          :id="card.payerid"
          class="stored-card-payer"
          :value="card.payerid"
        >
          <storedCC :card="card" />
        </b-form-radio>
      </span>
    </div>
  </div>
</template>

<script>
import storedCC from './storedCC.vue'

export default {
  name: 'store-credit-card-list',
  components: {
    storedCC
  },
  props: {
    label: {
      type: String,
      require: false,
      default: 'Stored Credit Cards'
    },
    storedCards: {
      type: Array,
      required: true
    }
  }
}
</script>

<style>

</style>
